import type { VenmoPaymentResponse, VenmoPaymentPayload } from '@/types/venmo';
import type { AppchargeErrorType } from '@/types/payment';
import { VENMO_ERROR_MESSAGE_KEYS, VENMO_PAYMENT_STATUS } from '@/constants/venmo';

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const createVenmoPaymentPayload = (params: {
  provider: string;
  email: string;
  paymentMethodDisplayName: string;
  paymentMethodId: string;
  nonce: string;
  deviceData?: string;
}): VenmoPaymentPayload => ({
  paymentProvider: params.provider,
  receipt_email: params.email,
  paymentMethodDisplayName: params.paymentMethodDisplayName,
  paymentMethodId: params.paymentMethodId,
  params: {
    paymentNonce: params.nonce,
    deviceData: params.deviceData,
  },
});

export const isVenmoPaymentSuccess = (response: VenmoPaymentResponse): boolean => {
  return response.braintree?.status === VENMO_PAYMENT_STATUS.SUCCEEDED;
};

export const isVenmoPaymentFailed = (response: VenmoPaymentResponse): boolean => {
  return response.braintree?.status === VENMO_PAYMENT_STATUS.FAILED;
};

export const getVenmoErrorMessage = (
  response: VenmoPaymentResponse
): { message?: string; errorType?: AppchargeErrorType } => {
  return {
    message: response.braintree?.message,
    errorType: response.appChargeErrorType,
  };
};

export const getVenmoTokenizeErrorMessage = (errorCode: string | undefined, t: TranslateFn): string => {
  const messageKey = errorCode ? VENMO_ERROR_MESSAGE_KEYS[errorCode] : '';
  if (!messageKey) {
    return '';
  }

  return t(messageKey);
};
